import { render, staticRenderFns } from "./payment_unit_detail.vue?vue&type=template&id=6979b08e&"
import script from "./payment_unit_detail.vue?vue&type=script&lang=js&"
export * from "./payment_unit_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports